export default __webpack_public_path__ + "static/media/862.3e531d67.png";